var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnleashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 145.2 93.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#e31837}.st1{fill:#a41d2a}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 86.8v-9.9h4.4v9.7c0 2 1.2 3.4 3.5 3.4s3.5-1.4 3.5-3.4v-9.7h4.3v9.9c0 4.1-2.5 7-7.8 7-5.4 0-7.9-2.9-7.9-7zM29 93.5l-7-9.6v9.6h-4.3V76.9h4.4l6.7 9.1v-9.1h4.3v16.6H29zM36 93.5V76.9h4.3v12.9H47v3.7H36zM48.7 93.5V76.9h12.2v3.7H53v2.6h7.7V87H53v2.8h7.9v3.7H48.7zM75.1 93.5l-.8-2.4h-6.5l-.8 2.4h-4.9l6.2-16.6h5.4l6.2 16.6h-4.8zM71 81.2l-2.1 6.2h4.2L71 81.2zM79.9 91.2l2.3-3.3c1.2 1.2 3 2.2 5.3 2.2 1.4 0 2.3-.5 2.3-1.3 0-2.2-9.4-.4-9.4-6.8 0-2.8 2.3-5.3 6.6-5.3 2.7 0 5 .8 6.7 2.3l-2.3 3.2c-1.4-1.2-3.2-1.7-4.9-1.7-1.2 0-1.8.4-1.8 1.1 0 2 9.4.5 9.4 6.7 0 3.3-2.5 5.5-6.9 5.5-3.3 0-5.7-1.1-7.3-2.6zM107.3 93.5v-6.7h-6.9v6.7h-4.3V76.9h4.3v6.2h6.9v-6.2h4.3v16.6h-4.3zM114.6 93.5V76.9h12.2v3.7h-7.9v2.6h7.7V87h-7.7v2.8h7.9v3.7h-12.2zM129.3 93.5V76.9h7c5.2 0 9 3.1 9 8.3 0 5.2-3.8 8.3-9 8.3h-7zm11.5-8.3c0-2.6-1.5-4.6-4.6-4.6h-2.7v9.1h2.7c2.9.1 4.6-2 4.6-4.5z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 33.1l-7-2.7-24 17.2 31 11.8z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76 33.1v26.3l24.2-17.1V13.4L76 30.7z",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2 26.3L45 17.2V46l24.2-17.3z",
    className: "st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2 29l24-17.2L69.2 0 45 17.2l24.2 9.1z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnleashed);
export default __webpack_public_path__ + "static/media/unleashed.6d98efded7c96c46c12a55e8d663942b.svg";
export { ForwardRef as ReactComponent };